module.exports = __webpack_public_path__ + "img/519C8D_83DAC7_9DEDE0_2B5B4C-256px.bdd78fab.png";